import React from 'react';
import PropTypes from 'prop-types';

export const Note = ({ title, context, variant = 'warning', style }) => {
	return (
		<div className={`note ${variant}`} style={style}>
			{title && <div className="title"><i className="mytabworks icon-megaphone"/> {title}</div>}
			<p className="context">{!title && <i className="mytabworks icon-megaphone"/>} {context}</p>
		</div>
	);
};

Note.propTypes = {
	title: PropTypes.string,
	context: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	variant: PropTypes.oneOf([
		'success',
		'info',
		'warning',
		'danger',
		'secondary',
	]),
	style: PropTypes.object,
};
